import React from 'react';

import BtnSlider from '../BtnSlider';
import ArrowSvg from '../BtnSlider/ArrowSvg';

import SC from './filterElements';

const FilterCategories = ({ start, end, active, open, filterCategories, dispatch, type }) => {
  const handleCategory = (index, filterId) => {
    dispatch({
      type: 'SET_ACTIVE_SLIDE',
      index,
      filterId,
    });
  };
  const COUNT = 1;
  return (
    <SC.CategoryWrapper data-open={open} type={type}>
      {type === 'mobile' ? (
        <div className="slider" open={open}>
          {filterCategories.map((slide, i) => {
            return (
              <SC.StyledCategory
                data-active={active === i}
                data-open={open}
                data-first={i === 0 && open}
                onClick={() => handleCategory(i, slide.id)}
                key={slide.id}
                data-testid={`mobile-cat-${i}`}
              >
                {slide.name}
              </SC.StyledCategory>
            );
          })}
          <button
            onClick={() =>
              dispatch({
                type: 'TOGGLE_FILTERS',
              })
            }
            data-open={open}
            data-active-tag={open && active}
            className="btn-toggle"
            data-testid="toggle-filter"
          >
            <ArrowSvg color={SC.theme.colors.purple} />
          </button>
        </div>
      ) : (
        <div className="slider">
          {start >= 1 && (
            <BtnSlider
              moveSlide={() =>
                dispatch({
                  type: 'SET_PREV_SLIDE',
                  value: filterCategories.slice(start - COUNT, end - COUNT)[active].id,
                })
              }
              direction={'prev'}
              active={active}
              testid="prev-cat"
            />
          )}
          {filterCategories.slice(start, end).map((slide, i) => {
            return (
              <SC.StyledCategory
                first={0}
                last={i === 4}
                data-active={active === i}
                onClick={() => handleCategory(i, slide.id)}
                key={slide.id}
                data-testid={`desktop-cat-${i}`}
              >
                {slide.name}
              </SC.StyledCategory>
            );
          })}
          {filterCategories.length > end && (
            <BtnSlider
              moveSlide={() =>
                dispatch({
                  type: 'SET_NEXT_SLIDE',
                  value: filterCategories.slice(start + COUNT, end + COUNT)[active].id,
                })
              }
              direction={'next'}
              active={active}
              testid="next-cat"
            />
          )}
        </div>
      )}
    </SC.CategoryWrapper>
  );
};

export default FilterCategories;
